import { render, staticRenderFns } from "./StatusBilheteBetbuilder.vue?vue&type=template&id=fdb89f0a&scoped=true"
import script from "./StatusBilheteBetbuilder.vue?vue&type=script&lang=js"
export * from "./StatusBilheteBetbuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb89f0a",
  null
  
)

export default component.exports